var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandyman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4644_3457)",
    filter: "url(#filter0_dii_4644_3457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5639 42.9996C44.2644 42.9996 46.6843 43.5127 48.8601 44.5109C51.0484 45.4963 52.9301 47.0322 54.5426 49.0796C54.8369 49.4379 55.1063 49.8354 55.3239 50.2959C55.5413 50.7564 55.6438 51.2047 55.6439 51.6396C55.6439 52.5996 55.2851 53.4446 54.6451 54.0846C54.0051 54.763 53.1729 55.0834 52.2001 55.0834C51.2279 55.0832 50.5114 54.7881 50.0764 54.1996C48.8094 52.8175 47.5663 51.7171 46.3889 50.8596C45.2114 50.0024 43.6756 49.5659 41.8201 49.5659C40.2332 49.566 38.7988 49.9376 37.6214 50.6671C36.4441 51.4094 35.5226 52.4078 34.8826 53.6746C34.2555 54.9417 33.9352 56.3632 33.9351 57.9246C33.9351 59.1916 34.0758 60.4852 34.3701 61.8034C34.6645 63.1213 35.0997 64.5423 35.6626 66.0521C36.2001 67.5622 36.8406 69.2014 37.5189 70.9546H47.2601C48.2197 70.9547 49.0391 71.3139 49.6789 71.9534C50.3058 72.5931 50.6261 73.4125 50.6264 74.3209C50.6264 75.2809 50.3189 76.1137 49.6789 76.7921C49.039 77.4703 48.2327 77.8158 47.2601 77.8159H38.0314C37.9674 80.3245 37.7359 82.8467 37.3264 85.4321C36.9296 88.0175 36.277 90.6293 35.3939 93.2659H51.8551C52.2135 92.562 52.5339 91.8833 52.8539 91.2434C53.1738 90.5652 53.5059 89.9759 53.8514 89.4384C54.2097 88.901 54.607 88.4658 55.0676 88.1459C55.5231 87.8296 56.1042 87.6635 56.7726 87.6596C57.7261 87.6633 58.5661 88.0089 59.2026 88.6834C59.8806 89.3743 60.2 90.1938 60.2001 91.1021C60.2001 91.6908 60.0594 92.2283 59.7651 92.7146L57.1289 98.0659C56.7323 98.7439 56.2712 99.2553 55.7339 99.6009C55.1964 99.9464 54.6199 100.113 53.9801 100.113H30.4914C29.3527 100.113 28.52 99.7545 27.9314 99.1146C27.3432 98.4748 27.0489 97.6554 27.0489 96.7471C27.0489 96.2098 27.1257 95.7616 27.2664 95.3521C28.5335 92.3058 29.5064 89.3483 30.1464 86.4171C30.8247 83.4862 31.1451 80.6057 31.1451 77.7771H27.6251C26.6654 77.777 25.82 77.4316 25.1801 76.7534C24.5022 76.0879 24.1815 75.2558 24.1814 74.2834C24.1815 73.3748 24.5403 72.5545 25.1801 71.9146C25.82 71.2366 26.6528 70.9173 27.6251 70.9171H30.4789C29.7494 68.8951 29.1346 67.2049 28.6226 65.7459C28.0852 64.3253 27.7139 62.9547 27.4451 61.6621C27.1764 60.3696 27.0364 59.0251 27.0364 57.6046C27.0365 54.9424 27.6756 52.4842 28.9939 50.2571C30.3122 48.0557 32.0669 46.2767 34.2939 44.9584H34.2676C36.5075 43.6401 38.8633 42.9997 41.5639 42.9996Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1014 67.9721C98.1014 67.9721 104.053 69.4195 106.101 79.5434C106.805 83.0757 107.267 85.3808 107.574 86.8784C107.919 88.5679 106.972 90.2443 105.359 90.8459C98.2294 93.4954 89.0645 94.4309 78.7864 94.4309H69.0839C67.1129 94.4309 65.1791 94.3924 63.2976 94.3284C63.8224 93.3428 64.0914 92.2669 64.0914 91.1021C64.0912 89.1824 63.3743 87.4159 62.0176 86.0209C60.661 84.6006 58.8052 83.8197 56.8089 83.8196C55.3243 83.8197 53.967 84.2292 52.8664 84.9971C52.0089 85.5987 51.2657 86.3925 50.6514 87.3396C50.2548 87.9538 49.8702 88.6317 49.4864 89.4121H40.7576C40.6811 89.2972 40.6162 89.182 40.5651 89.0671C40.7955 88.0434 40.9878 87.0193 41.1414 86.0084C41.3845 84.511 41.5637 83.0639 41.6789 81.6434H47.2851C49.2947 81.6434 51.0865 80.8873 52.4689 79.4409C53.7872 78.0713 54.4789 76.2283 54.4789 74.3084C54.4787 72.3887 53.7871 70.6606 52.4689 69.2784L52.4176 69.2271C51.7778 68.5875 51.0609 68.0876 50.2676 67.7421L61.8514 62.5321L69.0839 86.3021L71.6439 73.7584H76.2389L78.7864 86.3021L86.0176 62.5321L98.1014 67.9721Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0176 68.4721L76.2776 72.5171H71.5926L69.8514 68.4721L70.8764 66.7309H76.9939L78.0176 68.4721Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9351 19.8446C73.9865 19.8413 87.6069 18.6734 88.7451 31.7609C88.9615 34.192 88.4558 38.9156 88.4501 38.9684C88.4501 38.9684 90.0248 39.0458 90.1914 41.2596C90.3577 43.4742 90.0883 48.4524 86.4026 50.5771C86.4026 50.5771 84.2262 62.0458 73.9351 62.0459C63.6316 62.0455 61.4676 50.5771 61.4676 50.5771C57.7824 48.4522 57.5126 43.4741 57.6789 41.2596C57.8437 39.0815 59.3879 38.9705 59.4201 38.9684C59.4138 38.9092 58.9089 34.1903 59.1251 31.7609C60.2734 18.7044 73.8325 19.8359 73.9351 19.8446Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7451 0.248383C66.2683 0.248383 67.7788 0.299433 69.2764 0.414633C102.505 2.73145 128.745 30.4308 128.745 64.2484C128.745 71.9924 127.363 79.4298 124.841 86.3034C115.856 110.777 92.3418 128.248 64.7451 128.248C29.4043 128.248 0.745132 99.5892 0.745132 64.2484C0.745132 28.9076 29.4043 0.248383 64.7451 0.248383ZM64.7451 7.92838C43.2539 7.92838 24.5274 20.0373 15.0426 37.7909C10.8187 45.6885 8.42513 54.6868 8.42513 64.2484C8.42513 95.3012 33.6923 120.568 64.7451 120.568C87.5035 120.568 107.152 107 116.035 87.5184C119.261 80.4273 121.065 72.5426 121.065 64.2484C121.065 33.1956 95.7979 7.92838 64.7451 7.92838Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4644_3457",
    x: -0.00000339746,
    y: 0.00000396371,
    width: 129.49,
    height: 130.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4644_3457"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4644_3457",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4644_3457"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4644_3457",
    result: "effect3_innerShadow_4644_3457"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4644_3457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.745132 0.248383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandyman);
export default __webpack_public_path__ + "static/media/handyman.c99b6d022f19dde4ffea9b390f689441.svg";
export { ForwardRef as ReactComponent };